<div *ngFor="let item of items" class="item">
        <div class="image" [style.background-image]="'url('+item.image+')'"></div>
        <div class="name w-30">{{item.name}}</div>
        <div class="region w-30">{{item.region}}</div>
        <div>
            <!--Deleting the item trigger-->
            <i (click)="delete.emit(item.id)" class="fas fa-trash" placement="top" ngbTooltip="Delete"></i>
            <!--Editing the item trigger-->
            <i (click)="edit.emit(item)" class="fas fa-edit" placement="top" ngbTooltip="Edit"></i>
        </div>
</div>
